// extracted by mini-css-extract-plugin
module.exports = {"container":"_1gS2cB0nPwIo907oT6Z98b","label":"i1HrQEXsT4yODrexOv9zh"};